import { Button, Form } from 'react-bootstrap'
import { useFormContext } from 'react-hook-form'
import styled from 'styled-components'

const ColorButton = styled(Button)`
  && {
    flex: 1;
    background-color: ${(props) => `${props.color}`};
    color: #fff;
    font-size: 75%;
    line-height: 1;
    white-space: nowrap;
    padding: 0.4rem 0;
  }
`

const ColorInput = ({ controlId, label }) => {
  const {
    register,
    setValue,
    formState: { errors }
  } = useFormContext()

  const handleClick = (color) =>
    setValue(controlId, color, { shouldDirty: true })

  return (
    <>
      <Form.Group controlId={controlId}>
        <Form.Label className='font-weight-bold'>{label}</Form.Label>
        <Form.Control
          type='text'
          {...register(controlId)}
          isInvalid={!!errors[controlId]}
        />
        <Form.Text className='text-muted'>
          Choose from preset colors or enter a custom hex code (e.g., #000000)
        </Form.Text>
        <Form.Control.Feedback type='invalid'>
          {errors[controlId]?.message}
        </Form.Control.Feedback>
      </Form.Group>
      <div className='d-flex flex-wrap' style={{ gap: '.5rem' }}>
        <ColorButton color='#3F4443' onClick={() => handleClick('#3F4443')}>
          Gray Dark #3F4443
        </ColorButton>
        <ColorButton color='#BA0C2F' onClick={() => handleClick('#BA0C2F')}>
          Scarlet #BA0C2F
        </ColorButton>
        <ColorButton color='#2E7FA1' onClick={() => handleClick('#2E7FA1')}>
          Dark Blue #2E7FA1
        </ColorButton>
      </div>
    </>
  )
}
export { ColorInput }
